/**
 * AlertDialog - Reużywalny dialog alertu z Radix UI
 * wojskaspecjalne.pl
 */

import React from 'react';
import { Info, CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  Button,
  Alert,
  AlertDescription,
} from '../ui';

interface AlertDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  variant?: 'info' | 'success' | 'warning' | 'error';
  buttonLabel?: string;
  onClose?: () => void;
}

export const AlertDialog: React.FC<AlertDialogProps> = ({
  open,
  onOpenChange,
  title,
  description,
  variant = 'info',
  buttonLabel = 'OK',
  onClose,
}) => {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    onOpenChange(false);
  };

  // Icons for different variants
  const IconComponent = {
    info: Info,
    success: CheckCircle2,
    warning: AlertTriangle,
    error: XCircle,
  }[variant];

  const Icon = IconComponent;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="2">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Icon className="w-5 h-5" aria-hidden="true" />
            <span>{title}</span>
          </DialogTitle>
        </DialogHeader>

        <Alert variant={variant} className="mb-4">
          <AlertDescription>{description}</AlertDescription>
        </Alert>

        <DialogFooter>
          <Button variant="solid" onClick={handleClose}>
            {buttonLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

